<template>
  <RevForm
    :id="FORM_ID"
    class="my-12"
    :initial-values="INITIAL_VALUES"
    @submit="handleSubmit"
  >
    <template #default="{ values, errors }">
      <RevInputSelect
        v-if="isFeatureEnabled('multiEncodingEnabled')"
        id="select-encoding"
        v-model="values.encoding"
        class="mb-12"
        :error="errors.encoding"
        :label="i18n(translations.encoding)"
        :options="encodingOptions"
      />

      <RevInputSelect
        id="select-delimiter"
        v-model="values.delimiter"
        class="mb-12"
        :error="errors.delimiter"
        :label="i18n(translations.delimiter)"
        :options="delimiterOptions"
      />

      <RevInputFileUpload
        id="input-files"
        v-model="values.files"
        :accept="['.csv']"
        class="mb-12"
        :description="i18n(translations.fileFormat)"
        :label-empty="i18n(translations.file)"
        :max-files="1"
      />
    </template>
  </RevForm>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevForm } from '@ds/components/Form'
import { RevInputFileUpload } from '@ds/components/InputFileUpload'
import { RevInputSelect } from '@ds/components/InputSelect'

import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import { FORM_ID, INITIAL_VALUES } from '../../ImportDrawer.constants'
import type { FormValues } from '../../ImportDrawer.types'

import translations from './Form.translations'

const i18n = useI18n()

const { isFeatureEnabled } = useBusinessFeaturesStore()

const emit = defineEmits(['submit'])

const delimiterOptions = [
  { value: ',', label: i18n(translations.optionDelimiterComma) },
  { value: ';', label: i18n(translations.optionDelimiterSemicolon) },
  { value: '\\t', label: i18n(translations.optionDelimiterTab) },
]
const encodingOptions = [
  { value: 'utf-8', label: 'UTF-8' },
  { value: 'latin1', label: 'Latin-1 (CP-1252)' },
]

function handleSubmit(formValues: FormValues) {
  emit('submit', formValues)
}
</script>
